import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';
import { useEffect, useState, useRef } from 'react';
import { Input, Select, Button } from '../components/input';
import { Loading } from '../components/loading';
import { LeftNav } from '../components/nav';
import { Error } from '../components/error';
import { useQpms } from '../state';
import { proxies } from '../constants';

export default function QpmsPage() {
  const second = 1; // api units is minutes
  const minute = 60 * second;
  const hour = 60 * minute;
  const choices = [
    [5 * second, '5s'],
    [10 * second, '10s'],
    [30 * second, '30s'],
    [minute, '1m'],
    [5 * minute, '5m'],
    [10 * minute, '10m'],
    [30 * minute, '30m'],
    [hour, '1h'],
    [4 * hour, '4h'],
  ];
  const proxyChoices = proxies.map((it) => [it, it]);

  const [error, setError] = useState();
  const [url, setUrl] = useState('https://pokemondb.net/pokedex/national');
  const [domain, setDomain] = useState();
  const [window, setWindow] = useState(hour);
  const [proxy, setProxy] = useState();
  const { loading, qpms, update } = useQpms();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    try {
      setDomain(new URL(url).origin);
    } catch {
      setError('Invalid URL');
      return;
    }
    update(url, window, proxy);
  };

  useEffect(() => {
    update(url, window, proxy);
  }, [window, proxy]);

  const numStyle = {
    width: 100,
    fontSize: 12,
    fontFamily: 'monospace',
    padding: '3px 5px',
  };

  const rows = (qpms || [])
    .sort((a, b) => b.start - a.start)
    .map((it) => {
      const date = new Date();
      date.setTime(it.start);
      return (
        <tr>
          <td style={numStyle}>{format(date, 'yyyy-MM-dd HH:mm:ss')}</td>
          <td style={numStyle}>{it.count}</td>
          <td style={numStyle}>{it.qpm.toFixed(2)}</td>
          <td style={numStyle}>{(it.successRate * 100).toFixed(1)}%</td>
        </tr>
      );
    });

  const points = (qpms || []).map((it) => {
    // console.log('map point:', it);
    const ts = it.end;
    const now = new Date().getTime();
    const delta = now - ts;
    const days = delta / (24 * 3600 * 1000);
    const opacity = 1 / Math.pow(2, days);
    console.log('delta', delta, days, opacity);

    return {
      x: it.qpm.toFixed(2),
      y: (it.successRate || 0).toFixed(2),
      age: days,
      opacity,
    };
  });

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 5 }}>
          <div>
            <Input
              placeholder="https://example.com"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              style={{ width: 600 }}
            />
          </div>
          <Button>Submit</Button>
          <div>
            <Select noEmpty value={window} onChange={setWindow} choices={choices} />
          </div>
          <div>
            <Select value={proxy} onChange={setProxy} choices={proxyChoices} />
          </div>
          <div>{loading && <Loading />}</div>
        </div>
      </form>
      <Error message={error} />
      <p>
        {url}, {window}sec, {proxy}
      </p>

      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div style={{ width: '50%' }}>
          <table style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th style={{ width: 200 }}>time</th>
                <th>visits</th>
                <th>qpm</th>
                <th>ok</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </table>
        </div>
        {qpms.length > 0 && (
          <div style={{ width: '50%' }}>
            <ResponsiveContainer width="100%" height={400}>
              <ScatterChart margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
                <CartesianGrid />
                <XAxis
                  type="number"
                  dataKey="x"
                  name="qpm"
                  label={{ value: 'qpm', position: 'bottom', style: { textAnchor: 'middle' } }}
                />
                <YAxis
                  type="number"
                  dataKey="y"
                  name="success rate"
                  label={{ value: 'success rate', angle: -90, position: 'left', style: { textAnchor: 'middle' } }}
                />
                <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                <Scatter data={points} fill="#8884d8" />
              </ScatterChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>

      {/*
      <pre>{JSON.stringify(qpms, null, 2)}</pre>
      */}
    </div>
  );
}
